import React, {useEffect} from 'react';
import {useForm, useFormState} from 'react-hook-form';
import {View, Text, StyleSheet} from 'react-native';
import {Color, globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import {globalFormStyle} from '../../../assets/GlobalStyle/globalFormStyle';
import Width from '../../../assets/Width';
import {Input} from '../../../components/core/Input';
import {
  defaultRange,
  getMinSellSharesByPriceRange,
  isMobile,
} from '../../../utils/commonMethods';
import {
  globalConfigurableData,
  globalConst,
} from '../../../utils/globalConstant';
import {Network} from '../../../utils/network';
import TradingFeeSellCDA from '../childComponents/tradingFeeSellCda';
import TitleComponent from '../../event/childComponents/TitleComponent';
import {useNavigation} from '@react-navigation/native';
import {useSelector} from 'react-redux';
import {INDIA} from '../../../utils/constants';
import {smile_coin_black} from '../../../utils/images';
import FastImage from '../../../common/FastImage';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {Button} from '../../../components/core/Button';

const MergeForm = ({eventDetails, orderStatus, closeSheet}) => {
  const {probe} = eventDetails;
  const navigation = useNavigation();
  const {
    control,
    formState: {errors, isValid, isSubmitting},
    handleSubmit,
    reset,
    setValue,
    setError,
    clearErrors,
    watch,
  } = useForm({mode: 'onChange'});
  const {dirtyFields} = useFormState({
    control,
  });

  let userInfo = useSelector(({profile}) => profile.profileData);
  const watchshare = watch('currentShare');
  const watchAmount = watch('currentAmount', 0);

  useEffect(() => {
    getTotalAmountRecieve();
  }, [watchshare]);

  const matched_yes_contracts = probe.total_matched_contract_yes
    ? probe.total_matched_contract_yes
    : 0;
  const matched_no_contracts = probe.total_matched_contract_no
    ? probe.total_matched_contract_no
    : 0;

  const minContacts =
    (matched_yes_contracts > matched_no_contracts
      ? matched_no_contracts
      : matched_yes_contracts) * (100 / defaultRange?.end ?? 100);

  useEffect(() => {
    reset({
      currentShare: (minContacts).toFixed(2),
    });
  }, [matched_yes_contracts, matched_no_contracts]);

  const returnShare = () => {
    if (dirtyFields.currentShare) {
      return watchshare;
    } else {
      return minContacts;
    }
  };

  const getTotalAmountRecieve = async () => {
    if (watchshare >= 0) {
      const instantSharePayload = {
        appVersion: globalConst.appVersion,
        probeid: probe.id,
        shares: parseFloat(returnShare()),
        range: defaultRange.end,
      };

      const res = await Network.getAmountMergeShare(instantSharePayload);

      if (res && res?.data && res?.data?.status !== 'failed') {
        setValue('currentAmount', res?.data?.totalAmount?.toFixed(2) || 0);
        //setTradingFee(res.data?.trading_fee.toFixed(2) || 0);
        clearErrors('registerInput');
      } else {
        setError('registerInput', {
          type: 'custom',
          message: res?.data?.error,
        });
      }
    }
  };

  let region = userInfo?.region_code ?? 'INDIA';

  const onPlaceOrder = async data => {
    if (!userInfo?.isProfileComplete) {
      isMobile() && closeSheet();
      navigation.navigate('Profile');
      return;
    }
    let inputObj = {
      appVersion: globalConst.appVersion,
      userId: userInfo?.userid,
      probeid: probe.id,
      shares: parseFloat(returnShare()),
      range: defaultRange.end,
    };
    if (!isSubmitting) {
      let res
      if (probe.is_price_editable) {
        res = await Network.mergeShareCda(inputObj, true);
      }
      else {
        res = await Network.mergeShare(inputObj, true);
      }
      orderStatus(res, true);
    }
  };
  return (
    <>
      <View
        style={[
          {
            flex: 1,
            alignItems: 'stretch',
            paddingTop: isMobile() ? 0 : 15,
          },
          isMobile() ? {width: Width.width} : null,
        ]}>
        <TitleComponent eventInfo={eventDetails?.probe} />
        <View
          style={{
            borderBottomWidth: 0.75,
            borderBottomColor: globalConfigurableData.borderColor,
            marginHorizontal: 15,
          }}>
          <Text
            style={[
              styles.selectedFormTypeBlock,
              globalFontStyle.appFontSubHeading,
            ]}>
            Merge Shares Details
          </Text>
        </View>
        <View
          style={{
            paddingHorizontal: 15,
            paddingVertical: 5,
            justifyContent: 'space-between',
          }}>
          <View
            style={{...globalFormStyle.tableContainerRow, paddingBottom: 10}}>
            <View>
              <Text style={globalFormStyle.fieldLeft}>No of shares</Text>
            </View>
          </View>
          <Input
            name="currentShare"
            control={control}
            variant={errors?.registerInput?.type === 'custom' ? "error" : "default"}
            size="default"
            numeric={true}
            textAlign="left"
            rules={{
              required: true,
              min: getMinSellSharesByPriceRange(),
              max: minContacts,
            }}
          />
          {(!(errors?.registerInput?.type) && errors?.currentShare?.type === 'min') && (
            <FormTextLabel
              labelStyles={globalStyle.errorText}
              label={
                minContacts.toFixed(2) > 0
                  ? minContacts.toFixed(2) < 0.1
                    ? 'Quantity should be '
                    : 'Quantity should be between 0.1'
                  : 'Shares should be greater than 0'
              }
              rest={{
                valueShareMaxHoldings: parseFloat(minContacts).toFixed(2),
                minShares: getMinSellSharesByPriceRange(),
              }}
            />
          )}
          {errors?.registerInput?.type === 'custom' && (
            <Text style={globalStyle.errorText}>
              {errors.registerInput.message}
            </Text>
          )}
          <View style={{...globalFormStyle.tableContainerRow, paddingTop: 25}}>
            <View>
              <Text style={globalFormStyle.fieldLeft}>
                {eventDetails?.probe?.probe_type === 'promo'
                  ? 'Tokens Received'
                  : 'Amount Received'}
              </Text>
              <Text style={globalFormStyle.fieldLeft1}>
                Worth {watchshare || 0} shares of Yes and No each
              </Text>
            </View>

            <View style={{flexDirection: 'row', alignItems: 'center'}}>
              {eventDetails?.probe?.probe_type === 'promo' && (
                <FastImage
                  style={{width: 15, height: 15, marginRight: 4}}
                  source={smile_coin_black()}
                />
              )}
              <Text
                style={{
                  color: globalConfigurableData.primaryTextColor1,
                  ...globalFontStyle.appFontBody,
                }}>
                {watchAmount}
              </Text>
            </View>
          </View>
          <TradingFeeSellCDA configKey={'tfMergeShare'} />
        </View>
      </View>

      <View
        style={[
          globalStyle.customBtnParentModalStyle,
          {paddingHorizontal: 15, paddingTop: 30},
        ]}>
        <Button
          variant={isValid ? 'primary' : 'primary-inactive'}
          onPress={handleSubmit(onPlaceOrder)}
          disabled={!isValid}
        >
          Merge Share
        </Button>
      </View>
    </>
  );
};

export default MergeForm;

const styles = StyleSheet.create({
  infoStyle: {
    width: 12.5,
    height: 12.5,
  },
  selectedFormTypeBlock: {
    paddingHorizontal: 10,
    borderBottomWidth: 2,
    paddingVertical: 10,
    borderBottomColor: Colors.black,
    alignSelf: 'flex-start',
  },
});
